import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { OMS_BOOKABLE_CHECK_ENABLED } from '@scripts/woo_services.module/shared-types';
import { SystemService } from '@scripts/woo_services.module/SystemService';
import { ContextMessage } from '../context-message/context-message.component';

@Component({
  selector: 'oms-inventory-notice',
  imports: [ContextMessage, RouterLink],
  templateUrl: './oms-inventory-notice.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OmsInventoryNoticeComponent {
  private systemService = inject(SystemService);

  readonly visible = signal(false);

  constructor() {
    this.systemService.isFeatureToggleOn(OMS_BOOKABLE_CHECK_ENABLED).then((enabled) => this.visible.set(enabled));
  }
}
